<template>
    <div class="modify-loe-date">
        <Popup :class-name="showPopup ? 'open' : ''" @closePopup="closePopup" data-app>
            <h4 class="popup-title">
                <svg class="ico" width="15" height="15">
                    <use v-if="isAddForm" xlink:href="#ico-add"></use>
                    <use v-else xlink:href="#ico-edit"></use>
                </svg>
                <span>{{ isAddForm? 'Add' : 'Edit' }} Loss of Exclusivity for {{ selectedLoe.brand_name }}</span>
            </h4>
            <div class="popup-content content">
                <v-form @submit.prevent="handleSubmit" ref="form" class="">
                    <div class="form-content">
                        <v-flex xs12>
                            <label>Date of Limited Loss of Exclusivity</label>
                            <v-layout align-top class="mt-2">
                                <v-select
                                    class="loe-date-selector"
                                    :items="months"
                                    label="Month"
                                    v-model="form.limited_loe_month"
                                    :error-messages="errorsMessages.limited_loe_month"
                                    outline
                                    :disabled="loading"
                                    :menu-props="{
                                        closeOnContentClick: true,
                                    }"
                                >
                                    <template v-slot:prepend-item v-if="form.limited_loe_month != null">
                                        <v-list-tile
                                            ripple
                                            @click="form.limited_loe_month = null"
                                        >
                                            <v-list-tile-content>
                                                <v-list-tile-title>Clear</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                </v-select>
                                <v-select
                                    class="loe-date-selector ml-4"
                                    :items="years"
                                    label="Year"
                                    v-model="form.limited_loe_year"
                                    :error-messages="errorsMessages.limited_loe_year"
                                    outline
                                    :disabled="loading"
                                    :menu-props="{
                                        closeOnContentClick: true,
                                    }"
                                >
                                    <template v-slot:prepend-item v-if="form.limited_loe_year != null">
                                        <v-list-tile
                                            ripple
                                            @click="form.limited_loe_year = null"
                                        >
                                            <v-list-tile-content>
                                                <v-list-tile-title>Clear</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                </v-select>
                            </v-layout>
                        </v-flex>

                        <v-flex xs12>
                            <label>Date of Full Loss of Exclusivity</label>
                            <v-layout align-top class="mt-2">
                                <v-select
                                    class="loe-date-selector"
                                    :items="months"
                                    label="Month"
                                    v-model="form.full_loe_month"
                                    :error-messages="errorsMessages.full_loe_month"
                                    outline
                                    :disabled="loading"
                                    :menu-props="{
                                        closeOnContentClick: true,
                                    }"
                                >
                                    <template v-slot:prepend-item v-if="form.full_loe_month != null">
                                        <v-list-tile
                                            ripple
                                            @click="form.full_loe_month = null"
                                        >
                                            <v-list-tile-content>
                                                <v-list-tile-title>Clear</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                </v-select>
                                <v-select
                                    class="loe-date-selector ml-4"
                                    :items="years"
                                    label="Year"
                                    v-model="form.full_loe_year"
                                    :error-messages="errorsMessages.full_loe_year"
                                    outline
                                    :disabled="loading"
                                    :menu-props="{
                                        closeOnContentClick: true,
                                    }"
                                >
                                    <template v-slot:prepend-item v-if="form.full_loe_year != null">
                                        <v-list-tile
                                            ripple
                                            @click="form.full_loe_year = null"
                                        >
                                            <v-list-tile-content>
                                                <v-list-tile-title>Clear</v-list-tile-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                </v-select>
                            </v-layout>
                        </v-flex>
                    </div>

                    <div class="buttons vertical">
                        <v-btn type="submit" class="popup-btn" :loading="loading">{{ isAddForm ? 'ADD LOE' : 'SAVE'}}</v-btn>
                        <v-btn
                            type="button"
                            class="popup-btn secondary"
                            :disabled="loading"
                            @click="closePopup"
                            >CANCEL</v-btn
                        >
                    </div>
                </v-form>
            </div>
        </Popup>
    </div>
</template>

<script>
import Popup from "../../common/Popup";
import ValidationError from "../../../utils/ValidationError";

export default {
    components: {
        Popup
    },
    props: {
        selectedLoe: {
            type: Object
        },
        legendId: {
            type: String,
        },
    },
    computed: {
        chart() {
            return this.$store.getters['chart/getCurrentChart'];
        },
    },
    data() {
        return {
            showPopup: true,
            form: {
                limited_loe_year: null,
                limited_loe_month: null,
                full_loe_year: null,
                full_loe_month: null
            },
            isAddForm: false,
            errorsMessages: {},
            loading: false,
            originalSelectedLoeForm: null,
            months: [],
            years: []
        };
    },
    mounted() {
        this.months = Array.from({ length: 12 }, (_, i) => (i + 1).toString().padStart(2, "0"));
        this.years = Array.from({ length: 30 }, (_, i) => i + 2010);
        this.errorsMessages = {};
        this.isAddForm = this.selectedLoe.loe_date == null;

        if (this.isAddForm) {
            this.originalSelectedLoeForm = Object.assign({}, this.form);
        } else {

            this.originalSelectedLoeForm = {
                limited_loe_year: this.selectedLoe.limited_loe !== null ? this.selectedLoe.limited_loe.year : null,
                limited_loe_month: this.selectedLoe.limited_loe !== null && this.selectedLoe.limited_loe.month !== null ?
                     this.selectedLoe.limited_loe.month.toString().padStart(2,"0")
                    : null,
                full_loe_year: this.selectedLoe.full_loe !== null ? this.selectedLoe.full_loe.year : null,
                full_loe_month: this.selectedLoe.full_loe !== null && this.selectedLoe.full_loe.month !== null ?
                     this.selectedLoe.full_loe.month.toString().padStart(2,"0")
                    : null,
            };

            this.form = Object.assign({}, this.originalSelectedLoeForm);
        }
    },
    methods: {
        async handleSubmit() {
            this.errorsMessages = {};

            // check if not modified
            if( !this.isAddForm
                && this.originalSelectedLoeForm.limited_loe_year === this.form.limited_loe_year
                && this.originalSelectedLoeForm.limited_loe_month === this.form.limited_loe_month
                && this.originalSelectedLoeForm.full_loe_year === this.form.full_loe_year
                && this.originalSelectedLoeForm.full_loe_month === this.form.full_loe_month
            ){
                this.closePopup();
                return;
            }

            if (this.form.limited_loe_month != null && this.form.limited_loe_year == null)
                this.errorsMessages.limited_loe_year = "Year is required";

            else if (this.form.full_loe_month != null && this.form.full_loe_year == null)
                this.errorsMessages.full_loe_year = "Year is required";

            else if (this.isAddForm && this.form.full_loe_year == null && this.form.limited_loe_year == null)
                this.errorsMessages.limited_loe_year = "At least one date should be provided.";

            if (Object.keys(this.errorsMessages).length > 0) {
                return;
            }

            try {
                this.loading = true;

                const data = Object.fromEntries(
                        Object.entries(this.form).map(([k, v], i) => [k, parseInt(v, 10)])
                    );

                const updatedLoeEvents = await this.$store.dispatch("brand/update", {
                    id: this.selectedLoe.id,                    
                    ...data,
                });

                this.closePopup();

                this.$store.dispatch("chart/handleLoeEventsUpdate", { updatedLoeEvents, dataKey: this.legendId });


            } catch (error) {
                if (error instanceof ValidationError) {
                    this.errorsMessages = error.errors;
                } else {
                    console.error(error);
                    this.closePopup();
                }
            } finally {
                this.loading = false;
            }
        },
        closePopup() {
            this.showPopup = !this.showPopup;
            this.$emit("close");
        }
    }
};
</script>

<style lang="scss">
@import "../../../style/Charts/ViewChart/ModifyLoeDate";
</style>
